"use strict";

var serviceRequestControllers = angular.module("serviceRequestControllers", []);


serviceRequestControllers.controller("serviceListCtrl", ['$scope', '$q', '$translate', '$rootScope', '$location', '$interval', '$log', 'serviceRequestService', 'filterFilter', 'localStorageService', 'storageKeys', 'storeService', 'appSettings', '$sce', 'surveyService', 'clockService', 'Notification', 'sseService', 'impersonationService', '$http',
    function ($scope, $q, $translate, $rootScope, $location, $interval, $log, serviceRequestService, filterFilter, localStorageService, storageKeys, storeService, appSettings, $sce, surveyService, clockService, Notification, sseService, impersonationService, $http) {

        $scope.engineerRole=appSettings.engineerRole;
        $scope.serviceRequests = [];
        $scope.serviceRequestsGroupedByStoreCounters = [];
        $scope.counters = [];
        $scope.stores = [];
        $scope.srListDisplay = true;
        $scope.isInitialized = false
        $scope.statusList = {
            newServiceRequestSearcherTablet: "New",
            unansweredServiceRequestSearcherTablet: "Unanswered",
            signedInServiceRequestSearcherTablet: "Sign In",
            inProgressServiceRequestSearcherTablet: "On Site",
            onHoldServiceRequestSearcherTablet: "On Hold",
            pendingServiceRequestSearcherTablet: "Pending",
            awaitingCostApprovalServiceRequestSearcherTablet: "Awaiting Cost Approval",
            resolvedServiceRequestSearcherTablet: "Resolved"
        };
        $scope.pageInfo = {
            totalPages: 0,
            size: 14
        };

        $scope.searchFilter = "";
        $scope.filterJobsForEngineer = false;
        $scope.serviceRequestsNotFiltered = [];
        $scope.serviceRequestsFiltered = [];
        $scope.storeServiceRequestPaginationForEngineer = false;

        $scope.filter = {
            id: "inProgressServiceRequestSearcherTablet",
            page: 0,
            store: 0,
            engineerOnly: false
        };

        $scope.createRequest = function () {
            $location.path("/service-request-create");
        };

        $scope.viewRequest = function (index) {
            $location.path("/service-request-view/" + $scope.serviceRequests[index].id);
        };


        $scope.moveToImpersonationIfApplicable = impersonationService.redirectToImpersonationIfApplicable;

        $scope.hasRole = function (role) {
            var profile = localStorageService.get(storageKeys.profileKey);
            if (profile == null) return false;

            var found = filterFilter(profile.roles, role);
            return (found.length > 0);
        };

        $scope.storeMode = storeService.isStoreMode();

        $scope.engineerMode = function(){
            return localStorageService.get(storageKeys.loginTypeKey) === appSettings.engineerLoginType;
        };

        $scope.srListDisplay = $scope.storeMode;

        if (!$scope.storeMode) {
            localStorageService.remove(storageKeys.storeKey);
        }

        function loadCounters() {
            if (localStorageService.get(storageKeys.profileKey) !== null) {
                serviceRequestService.counters($scope.filter).then(function (resource) {
                    resource.$get("serviceRequestCountList").then(function (counters) {
                        $scope.counters = counters;
                    });
                });
            }
        }

        $scope.sseInitializeAndListen = function () {
            //commented it to test ES-4878

            //sseService.get();
            //sseService.subscribe($scope,triggerFetchAndUpdateUI);
        };

        function triggerFetchAndUpdateUI() {
            console.log("callback called!");
            loadCounters();
            $scope.paginate($scope.filter.page);
            $scope.notify($translate.instant('label.views.serviceRequestStatusChange'));
        }

        $scope.notify = function (message) {
            Notification.info(message);
        };

        $scope.paginate = function (page) {
            if ($scope.storeMode) {
                $scope.paginatedServiceRequests(page);
            } else {
                if($scope.storeServiceRequestPaginationForEngineer) {
                    $scope.paginatedServiceRequests(page);
                } else {
                    $scope.paginatedServiceRequestsGroupedByStore(page);
                }
            }
        };

        $scope.paginatedServiceRequestsGroupedByStore = function (page) {
            $scope.filter.page = page;
            $scope.filter.engineerOnly = $scope.filterJobsForEngineer;
            var pageInfo = {};

            var profile = localStorageService.get(storageKeys.profileKey);
            if (profile != null) {
                serviceRequestService.listGroupedByStore($scope.filter).then(function (resource) {
                    $scope.pageInfo = resource.page;
                    // change model to match store list with sr count and link to sr list
                    if (resource.$has("serviceRequestCountList")) {
                        resource.$get("serviceRequestCountList").then(function (counters) {
                            $scope.serviceRequestsGroupedByStoreCounters = counters;
                        });
                    }
                });
            }else{
                $log.error("ServiceRequestController: Profile should not be null")
            }
        };

        $scope.paginatedServiceRequests = function (page) {
            $scope.filter.page = page;
            $scope.filter.engineerOnly = $scope.filterJobsForEngineer;
            var pageInfo = {};
            $scope.searchFilter = "";

            var profile = localStorageService.get(storageKeys.profileKey);
            if (profile != null) {
                serviceRequestService.list($scope.filter).then(function (resource) {
                    $scope.pageInfo = resource.page;
                    if (resource.$has("serviceRequestList")) {
                        resource.$get("serviceRequestList").then(function (list) {
                            var srListPromises = [];

                            list.forEach(function (serviceRequestResource) {
                                // fetching ServiceEvent
                                var serviceRequest = {};
                                var srPromises = [];

                                srPromises.push(serviceRequestResource.$get("serviceEvent").then(function (event) {
                                    // fetching Machine
                                    return event.$get("machine").then(function (machine) {

                                        serviceRequest.status = serviceRequestResource.status;
                                        serviceRequest.approved = serviceRequestResource.approved;
                                        serviceRequest.approvedBy = serviceRequestResource.approvedBy;
                                        serviceRequest.approvedTime = serviceRequestResource.approvedTime;
                                        serviceRequest.cancellationReason = serviceRequestResource.cancellationReason;
                                        serviceRequest.cancelledByUser = serviceRequestResource.cancelledByUser;
                                        serviceRequest.created = clockService.getTimeFromString(serviceRequestResource.created);
                                        serviceRequest.createdBy = serviceRequestResource.createdBy;
                                        serviceRequest.eta = serviceRequestResource.eta;
                                        serviceRequest.extendedServiceConfirmed = serviceRequestResource.extendedServiceConfirmed;
                                        serviceRequest.id = serviceRequestResource.id;
                                        serviceRequest.notificationPhoneNumber = serviceRequestResource.notificationPhoneNumber;
                                        serviceRequest.notificationType = serviceRequestResource.notificationType;
                                        serviceRequest.ticketNumber = serviceRequestResource.ticketNumber;
                                        serviceRequest.deferralReason = serviceRequestResource.deferralReason;
                                        serviceRequest.costsDelegated = serviceRequestResource.costsDelegated;
                                        // Adding machine to the model
                                        serviceRequest.machine = machine;
                                    });
                                }));

                                if (serviceRequestResource.$has("store")) {
                                    srPromises.push(serviceRequestResource.$get("store").then(function (store) {
                                        serviceRequest.store = store;
                                    }));
                                }

                                if (serviceRequestResource.$has("engineer")) {
                                    srPromises.push(serviceRequestResource.$get("engineer").then(function (engineer) {
                                        serviceRequest.engineer = engineer;
                                    }))
                                }

                                srListPromises.push($q.all(srPromises).then(function () {
                                    return $q.when(serviceRequest)
                                }))
                            });

                            $q.all(srListPromises).then(function (serviceRequests) {

                                $scope.serviceRequestsFiltered = [];
                                $scope.serviceRequestsNotFiltered = angular.copy(serviceRequests);

                                if (profile != null && !$scope.storeMode && $scope.engineerMode()) {
                                    serviceRequests.forEach(function (sr) {

                                        if (sr.engineer.firstName == profile.firstName &&
                                            sr.engineer.lastName == profile.lastName) {

                                            $scope.serviceRequestsFiltered.push(sr);
                                        }
                                    });
                                }

                                if ($scope.filterJobsForEngineer) {
                                    $scope.serviceRequests = $scope.serviceRequestsFiltered;
                                } else {
                                    $scope.serviceRequests = serviceRequests;
                                }
                            })
                        })
                    } else {
                        return $q.when([]);
                    }
                })

            } else {
                $log.error("ServiceRequestController: Profile should not be null")
            }
        };

        $scope.applyFilter = function(filterId){
            $log.debug("ServiceRequestController: applying filter: "+ filterId)
            $scope.filter.id = filterId;
            $scope.searchFilter = "";

            if (!($scope.storeMode) && $scope.engineerMode()) {
                $scope.clearStoreFilter();
                $scope.paginatedServiceRequestsGroupedByStore(0);
            } else {
                $scope.paginatedServiceRequests(0);
            }
            loadCounters();
        };

        $scope.viewRequestsForStore = function (storeId, storeCode, storeName) {
            $scope.srListDisplay = true;
            $scope.filter.store = storeId;
            $scope.selectedStore = storeCode + " " + storeName;
            this.viewServiceRequestsForStore(storeId);
        };

        $scope.viewServiceRequestsForStore = function (storeId) {
            storeService.requestStoreAuthentication(storeId).then(function (store) {
                storeService.setStoreContext(store);
                $rootScope.$broadcast('setStoreTime', store);
                $scope.paginatedServiceRequests(0);
                $scope.storeServiceRequestPaginationForEngineer = true;
            });
        };

        function returnToMainScreen(){
            if(!$scope.storeMode){
                $scope.clearStoreFilter();
            }
            if(!$scope.storeMode && !($scope.engineerMode()) && $scope.hasRole(appSettings.hkAdminRole)){
                $location.path("#/impersonate");
            }else {
                $location.path("#/");
            }
            loadCounters();
            $scope.paginate(0);
        };

        $scope.clearStoreFilter = function () {
            $scope.srListDisplay = false;
            $scope.filter.store = $scope.selectedStore = null;
            $rootScope.$broadcast('removeStoreTime');
            storeService.removeStoreContext();
        };


        $rootScope.$on('event:profile-updated', function (event, data) {
            filterByStore();
        });

        $scope.viewSurveyQuestionaire = function (id) {
            surveyService.getSurvey(id).then(function (resource) {
                $scope.surveyUrl = $sce.trustAsResourceUrl(resource.url);
            });
        };

        // service request controller should only initialize when login has been completed.
        // as service request controller and login controller live on the same page
        // race condition is created.
        // To fix this controller is initialized in two ways:
        // - after redirect when login controller is finished logging in the user
        //   completed-login event is fired and controller initializes
        // - on page refresh controller checks for the existence of profile and
        //   and then initializes
        function initialize () {
            if($scope.hasRole(appSettings.hkAdminRole)){
                $log.debug("Admin logged in for impersonation, do not initialise Service Request List")
                return
            }
            if($scope.isInitialized){
                $log.error("ServiceRequestController: Already initialized")
                return
            }
            $scope.isInitialized =true
            $log.debug("ServiceRequestController: Initializing")
            var profile = localStorageService.get(storageKeys.profileKey);
            $scope.profile = profile;
            $scope.store = storeService.getStore();
            $rootScope.store = $scope.store

            // prevents duplicate timeout registrations as some code in vegas redirects to root
            // and forces service request controller initialization (returnToMainScreen)
            $interval.cancel($rootScope.serviceRequestList.refreshListIntervalPromise)
            $rootScope.serviceRequestList.refreshListIntervalPromise =  $interval(function() {
                $log.debug("ServiceRequestController: Reloading counters and list")
                loadCounters();
                $scope.paginate($scope.filter.page);
            }, appSettings.srListRefreshIntervalMillis);

            // deregister event
            if ($rootScope.serviceRequestList.mainMenuEventPromise) {
                $rootScope.serviceRequestList.mainMenuEventPromise()
            }
            // Fired from function that is attached to root scope
            // Current html layout prevents better implementation
            $rootScope.serviceRequestList.mainMenuEventPromise =
                $rootScope.$on('event:return-main-screen', function (event) {
                    $log.debug("ServiceRequestController: event:return-main-screen")
                    returnToMainScreen()
                });

            loadCounters();
            $scope.paginate(0);

            sseInitialize();
        }

        var profile = localStorageService.get(storageKeys.profileKey);
        if (profile && 'Authorization' in $http.defaults.headers.common) {
            $scope.moveToImpersonationIfApplicable();
            initialize();
        }
        else {
            $log.debug("ServiceRequestController: User profile not set, skip initialization and register completed-login event")
            $scope.$on('event:completed-login', function () {
                $log.debug("ServiceRequestController: Completed login")

                $scope.moveToImpersonationIfApplicable();
                initialize();
            });
        }

        if (profile != null && !$scope.storeMode && $scope.engineerMode()) {
            $scope.filterJobsForEngineer = true;
        }

        $scope.filterJobsForEngineerSelected = function () {
            if ($scope.filterJobsForEngineer) {
                $scope.serviceRequests = $scope.serviceRequestsFiltered;
            } else {
                $scope.serviceRequests = $scope.serviceRequestsNotFiltered;
            }
            $scope.paginate($scope.filter.page);
        }

        function sseInitialize(){
            if(sseService.isSSESupported()){
                $scope.sseInitializeAndListen();
            }
        }

        //commented it to test ES-4878

        /*if(sseService.isSSESupported()) {
            $interval(function () {
                $scope.sseInitializeAndListen();
            }, appSettings.srListRefreshIntervalMillisForSee);

        }else if (!($scope.hasRole(appSettings.engineerRole))) {
            $interval(function () {
                loadCounters();
                $scope.paginate($scope.filter.page);
            }, appSettings.srListRefreshIntervalMillis);
        }else{
            $interval(function () {
                loadCounters();
                $scope.paginate($scope.filter.page);
            }, appSettings.srListRefreshIntervalMillisForEngineer);
        }*/

        $rootScope.$on('event:serviceProviderFetched', function (event, data) {
            sseInitialize();
        });

        if (!($scope.hasRole(appSettings.engineerRole))) {
            $interval(function () {
                loadCounters();
                $scope.paginate($scope.filter.page);
            }, appSettings.srListRefreshIntervalMillis);
        }else{
            $interval(function () {
                loadCounters();
                $scope.paginate($scope.filter.page);
            }, appSettings.srListRefreshIntervalMillisForEngineer);
        }

        $scope.moveToImpersonationIfApplicable();
    }]);

serviceRequestControllers.controller("serviceRequestCreateCtrl",
    ['$scope', 'serviceRequestCreation','$log', '$translate',
        function($scope, serviceRequestCreation,$log, $translate) {

            serviceRequestCreation.createNewDto();

            $log.debug("ServiceRequestCreationController: Initializing")
            $scope.finishDone = false;
            $scope.step = 0;
            $scope.skippedSteps = [];

            $scope.localizableStepsHeaderKey = ['label.views.view.details.FaultType', 'label.views.view.details.SelectedItem', 'label.view.workflow.create.linkServiceRequest', 'label.views.service-creation.review.IssueDescription',
                'label.views.view.details.ServiceAgent', 'label.views.workflow.create.notification', 'label.views.workflow.create.review'];

            $scope.steps = [];
            $scope.localizableStepsHeaderKey.forEach(function (item) {
                $scope.steps.push($translate.instant(item));
            });

            $scope.templates = [
                'js/views/service-creation/faultType.tpl.html',
                'js/views/service-creation/affectedMachine.tpl.html',
                'js/views/service-creation/linkService.tpl.html',
                'js/views/service-creation/issueDescription.tpl.html',
                'js/views/service-creation/serviceAgent.tpl.html',
                'js/views/service-creation/notification.tpl.html',
                'js/views/service-creation/review.tpl.html'
            ];

            $scope.finish = function () {
                $scope.finishDone = true;
            };

            $scope.setStep = function (step) {
                if (!$scope.finishDone) {
                    if (step <= $scope.step){
                        $scope.step = step;
                        $scope.resetSkippedSteps(step);
                    }
                }
            };



            $scope.gotoReview = function () {
                $scope.step = $scope.steps.length - 1
            };


            $scope.next = function (isSkippedStep) {
                if (!$scope.finishDone) {
                    if ($scope.step < ($scope.steps.length - 1)) {
                        if(isSkippedStep)
                            $scope.markAsSkippedStep($scope.step+1);
                        $scope.step++;
                    }
                }
            };

            $scope.isSkippedStep = function(step){
                return $scope.skippedSteps.indexOf(step) !== -1;
            };

            $scope.markAsSkippedStep = function(step){
                if(!$scope.isSkippedStep(step))
                    $scope.skippedSteps.push(step);
            };



            $scope.resetSkippedSteps = function(step) {

                var stepIndex =  $scope.skippedSteps.indexOf(step) !== -1 ? $scope.skippedSteps.indexOf(step) :  $scope.skippedSteps.findIndex(function(item) {
                    return item > step;
                });

                if(stepIndex !== -1 &&  $scope.skippedSteps.length - stepIndex > 0)
                    $scope.skippedSteps.splice(stepIndex , $scope.skippedSteps.length - stepIndex);
            };


            $scope.previous = function () {
                if (!$scope.finishDone) {
                    if ($scope.step > 0){
                        $scope.step--;
                        $scope.resetSkippedSteps($scope.step);
                    }
                }
            };

        }]);

serviceRequestControllers.controller("serviceRequestSignInCtrl",
    ['$scope', 'lookUpService', '$routeParams', 'serviceRequestSignIn', 'localStorageService', 'storageKeys', 'filterFilter', 'appSettings',
        function ($scope, lookUpService, $routeParams, serviceRequestSignIn, localStorageService, storageKeys, filterFilter, appSettings) {

            serviceRequestSignIn.createNewDto();

            $scope.finishDone = false;
            $scope.step = 0;
            $scope.steps = [];
            $scope.templates = [];
            $scope.serviceRequest = {};
            $scope.skippedSteps = [];
            var profile = localStorageService.get(storageKeys.profileKey);

            if (filterFilter(profile.roles, appSettings.storeApproverRole) || filterFilter(profile.roles, appSettings.storeManagerRole)) {
                serviceRequestSignIn.setManager(profile);
                serviceRequestSignIn.setApprover(profile.username);
                serviceRequestSignIn.setSignedInBy(profile.username);
            }

            if (filterFilter(profile.roles, appSettings.engineerRole)) {
                serviceRequestSignIn.setEngineer(profile.engineer);
            }

            lookUpService.get('serviceRequest', $routeParams.serviceRequestId).then(function (resource) {
                $scope.serviceRequest = resource;
                serviceRequestSignIn.setServiceRequest(resource);

                resource.$get("workflow-signin").then(function (workflow) {
                    for (var i = 0; i < workflow.steps.length; i++) {

                        switch (workflow.steps[i].name) {
                            case "serviceRequestSignInChangeEngineer":
                                serviceRequestSignIn.getProperties().changeEngineer = true;
                                break;
                            case "hazard":
                                serviceRequestSignIn.getProperties().showSiteSpecificHazards = true;
                                break;
                            case "hazard_rating_":
                                serviceRequestSignIn.getProperties().showHazardRating = true;
                                break;
                            case "hazardAssessmentFastSignIn" :
                                serviceRequestSignIn.getProperties().fastSignIn = true;
                                break;
                        }

                        if (workflow.steps[i].enabled && workflow.steps[i].parentStep == null) {
                            $scope.steps.push(workflow.steps[i].localizableTitleKey);
                            $scope.templates.push('js/views/' + workflow.steps[i].template);
                        }
                    }
                });
            });

            $scope.finish = function () {
                $scope.finishDone = true;
            };

            $scope.setStep = function (step) {
                if (!$scope.finishDone) {
                    if (step <= $scope.step){
                        $scope.step = step;
                        $scope.resetSkippedSteps(step);
                    }
                }
            };

            $scope.next = function (isSkippedStep) {
                if (!$scope.finishDone) {
                    if ($scope.step < ($scope.steps.length - 1)) {
                        if(isSkippedStep)
                            $scope.markAsSkippedStep($scope.step+1);
                        $scope.step++;
                    }
                }
            };

            $scope.isSkippedStep = function(step){
                return $scope.skippedSteps.indexOf(step) !== -1;
            };

            $scope.markAsSkippedStep = function(step){
                if(!$scope.isSkippedStep(step))
                    $scope.skippedSteps.push(step);
            };



            $scope.resetSkippedSteps = function(step) {

                var stepIndex =  $scope.skippedSteps.indexOf(step) !== -1 ? $scope.skippedSteps.indexOf(step) :  $scope.skippedSteps.findIndex(function(item) {
                    return item > step;
                });

                if(stepIndex !== -1 &&  $scope.skippedSteps.length - stepIndex > 0)
                    $scope.skippedSteps.splice(stepIndex , $scope.skippedSteps.length - stepIndex);
            };


            $scope.previous = function () {
                if (!$scope.finishDone) {
                    if ($scope.step > 0){
                        $scope.step--;
                        $scope.resetSkippedSteps($scope.step);
                    }
                }
            };
        }]);

serviceRequestControllers.controller("serviceRequestSignOutCtrl",
    ['$scope', 'lookUpService', '$routeParams', 'serviceRequestSignOut', 'localStorageService', 'storageKeys', 'filterFilter', 'appSettings',
        function ($scope, lookUpService, $routeParams, serviceRequestSignOut, localStorageService, storageKeys, filterFilter, appSettings) {

            serviceRequestSignOut.createNewDto();

            $scope.finishDone = false;
            $scope.step = 0;
            $scope.steps = [];
            $scope.templates = [];
            $scope.serviceRequest = {};
            $scope.skippedSteps = [];

            var profile = localStorageService.get(storageKeys.profileKey);
            serviceRequestSignOut.setSignedOutBy(profile.username);

            if (filterFilter(profile.roles, appSettings.storeApproverRole) || filterFilter(profile.roles, appSettings.storeManagerRole)) {
                serviceRequestSignOut.setManager(profile);
            }

            lookUpService.get('serviceRequest', $routeParams.serviceRequestId).then(function (resource) {
                $scope.serviceRequest = resource;
                serviceRequestSignOut.setServiceRequest(resource);

                resource.$get("workflow-signout").then(function (workflow) {
                    for (var i = 0; i < workflow.steps.length; i++) {
                        if (workflow.steps[i].enabled && workflow.steps[i].parentStep == null) {
                            $scope.steps.push(workflow.steps[i].localizableTitleKey);
                            $scope.templates.push('js/views/' + workflow.steps[i].template);
                        }
                    }
                });

                resource.$get("engineer").then(function (engineer) {
                    serviceRequestSignOut.setEngineer(engineer);
                });

                resource.$get("store").then(function (store) {
                    serviceRequestSignOut.setStore(store);
                });
            });

            $scope.finish = function () {
                $scope.finishDone = true;
            };

            $scope.setStep = function (step) {
                if (!$scope.finishDone) {
                    if (step <= $scope.step){
                        $scope.step = step;
                        $scope.resetSkippedSteps(step);
                    }
                }
            };

            $scope.next = function (isSkippedStep) {
                if (!$scope.finishDone) {
                    if ($scope.step < ($scope.steps.length - 1)) {
                        if(isSkippedStep)
                            $scope.markAsSkippedStep($scope.step+1);
                        $scope.step++;
                    }
                }
            };

            $scope.isSkippedStep = function(step){
                return $scope.skippedSteps.indexOf(step) !== -1;
            };

            $scope.markAsSkippedStep = function(step){
                if(!$scope.isSkippedStep(step))
                    $scope.skippedSteps.push(step);
            };




            $scope.resetSkippedSteps = function(step) {

                var stepIndex =  $scope.skippedSteps.indexOf(step) !== -1 ? $scope.skippedSteps.indexOf(step) :  $scope.skippedSteps.findIndex(function(item) {
                    return item > step;
                });

                if(stepIndex !== -1 &&  $scope.skippedSteps.length - stepIndex > 0)
                    $scope.skippedSteps.splice(stepIndex , $scope.skippedSteps.length - stepIndex);
            };


            $scope.jump = function (numberOfSteps) {
                if (!$scope.finishDone) {
                    if (($scope.step + numberOfSteps) < $scope.steps.length) {

                        if(numberOfSteps === 1) {
                            var skippedStep = $scope.step + 2;
                            $scope.markAsSkippedStep(skippedStep);
                        }

                        $scope.step = $scope.step + numberOfSteps;
                    }
                }
            };

            $scope.previous = function () {
                if (!$scope.finishDone) {
                    if ($scope.step > 0){
                        $scope.step--;
                        $scope.resetSkippedSteps($scope.step);
                    }
                }
            };
        }]);

serviceRequestControllers.controller("serviceRequestViewCtrl",
    ['$scope', '$rootScope', 'lookUpService', '$routeParams', 'serviceRequestService', '$location', 'serviceRequestView', '$modal', '$log', '$translate', 'filterFilter', 'appSettings', 'authenticationService',
        function ($scope, $rootScope, lookUpService, $routeParams, serviceRequestService, $location, serviceRequestView, $modal, $log, $translate, filterFilter, appSettings, authenticationService) {

            $scope.modal = {
                url: ""
            };

            $scope.serviceRequest = {};
            $scope.availableActions = [];
            $scope.plannedMaintenance = false;
            $scope.queryNote = "";
            $scope.error = false;
            $scope.loading = true;

            $scope.actionMessage = "";

            $scope.srHasAction = function (action) {
                var found = filterFilter($scope.availableActions, action);
                return (found.length > 0);
            };

            $scope.isInProgress = function () {
                return $scope.serviceRequest.status.name === "IN_PROGRESS";
            };

            $scope.isSameEngineer = function () {
                return ($scope.hasUserRole(appSettings.engineerRole) &&
                $scope.engineer.firstName != $scope.profile.firstName &&
                $scope.engineer.lastName != $scope.profile.lastName)
            };

            function loadService() {
                if(authenticationService.validateCustomStoreContextHeaderByStoreId()) {
                    lookUpService.get('serviceRequest', $routeParams.serviceRequestId).then(function (resource) {
                        $scope.serviceRequest = resource;
                        serviceRequestView.setServiceRequest(resource);
                        $scope.viewIndex = 0;
                        $scope.loading = false;

                        if ($scope.serviceRequest.$has("engineer")) {
                            $scope.serviceRequest.$get("engineer").then(function (engineer) {
                                $scope.engineer = engineer;
                                $scope.removeSignout = ( $scope.isSameEngineer() && $scope.isInProgress() );
                            });
                        }

                        if ($scope.serviceRequest.$has('availableActions')) {
                            $scope.serviceRequest.$get('availableActions').then(function (actionsList) {
                                $scope.availableActions = actionsList.actions;

                                if ($scope.srHasAction("signout") && $scope.removeSignout) {
                                    $scope.availableActions.splice($scope.availableActions.indexOf("signout"), 1);
                                }
                            });
                        }

                        $scope.serviceRequest.$get("schedule-step").then(function (scheduleStep) {
                            $scope.plannedMaintenance = true;
                        });

                        $rootScope.$broadcast("serviceRequest:updated");
                    });
                } else {
                    $location.path('/service-request-list');
                }
            }

            $scope.$on("serviceRequest:message", function (event, data) {
                $scope.actionMessage = data.message;
                loadService();
            });

            $scope.approveCostBreakDown = function () {
                serviceRequestService.approveCostBreakDown($scope.serviceRequest.id).then(
                    function (response) {
                        var message = {
                            message: $translate.instant('label.controller.services.serviceRequestController.Approved'),
                            type: "success"
                        };
                        $("#modal-viewer").modal("hide");
                        $rootScope.$broadcast("serviceRequest:message", message);
                    }
                );
            };


            $scope.queryCostBreakDown = function () {
                if ($scope.queryNote !== "") {
                    serviceRequestService.queryCostBreakDown($scope.serviceRequest.id, $scope.queryNote).then(
                        function (response) {
                            var message = {
                                message: $translate.instant('label.controller.services.serviceRequestController.Queried'),
                                type: "success"
                            };
                            $("#modal-viewer").modal("hide");
                            $rootScope.$broadcast("serviceRequest:message", message);
                        }
                    );
                }
                else {
                    $scope.error = true;
                }
            };

            $scope.signIn = function () {
                $location.path("/service-request-signin/" + $scope.serviceRequest.id);
            };

            $scope.signOut = function () {
                $scope.serviceRequest.$get("store").then(function (store) {

                    $location.path("/service-request-signout/" + $scope.serviceRequest.id + "?store=" + store.id);
                });

            };

            $translate.onReady(function () {
                $scope.views[4].icon = $translate.instant('label.vegasCurrencyIcon');
            });

            $scope.views = [
                {
                    template: "js/views/view/details.tpl.html",
                    title: $translate.instant('label.controller.services.serviceRequestController.Details'),
                    enabled: true,
                    icon: "fa-list"
                },
                {
                    template: "js/views/view/history.tpl.html",
                    title: $translate.instant('label.controller.services.serviceRequestController.History'),
                    enabled: true,
                    icon: "fa-history"
                },
                {
                    template: "js/views/view/visits.tpl.html",
                    title: $translate.instant('label.controller.services.serviceRequestController.Visits'),
                    enabled: true,
                    icon: "fa-location-arrow"
                },
                {
                    template: "js/views/view/warranty.tpl.html",
                    title: $translate.instant('label.controller.services.serviceRequestController.Warranty'),
                    enabled: true,
                    icon: "fa-certificate"
                },
                {
                    template: "js/views/view/costSummary.tpl.html",
                    title: $translate.instant('label.controller.services.serviceRequestController.CostSummary'),
                    enabled: true,
                    icon: "fa-euro"
                },
                {
                    template: "js/views/view/results.tpl.html",
                    title: $translate.instant('label.controller.services.serviceRequestController.DResults'),
                    enabled: true,
                    icon: "fa-flag-checkered"
                },
                {
                    template: "js/views/view/notes.tpl.html",
                    title: $translate.instant('label.controller.services.serviceRequestController.Notes'),
                    enabled: true,
                    icon: "fa-edit"
                }
            ];

            $scope.loadView = function (index) {
                $scope.viewIndex = index;
            };

            $scope.showCancelReasons = function () {
                $scope.modal.url = "js/views/view/cancelServiceRequest.tpl.html";
                $("#modal-viewer").modal("show");
            };

            $scope.showCancelOnHold = function () {
                $scope.modal.url = "js/views/view/cancelServiceRequestOnHold.tpl.html";
                $("#modal-viewer").modal("show");
            };

            $scope.determineCancellation = function () {
                if ($scope.serviceRequest.status.name === 'ON_HOLD') {
                    $scope.showCancelOnHold();
                } else {
                    $scope.showCancelReasons();
                }
            };

            $scope.openApproveServiceRequestModal = function () {
                $scope.modal.url = "js/views/view/approveServiceRequest.tpl.html";
                $("#modal-viewer").modal("show");
            };

            $scope.openApproveModal = function () {
                $scope.modal.url = "js/views/view/approveCostBreakdown.tpl.html";
                $("#modal-viewer").modal("show");
            };

            $scope.openQueryModal = function () {
                $scope.modal.url = "js/views/view/queryCostBreakdown.tpl.html";
                $("#modal-viewer").modal("show");
            };

            $scope.openResubmitModal = function () {
                $scope.modal.url = "js/views/view/resubmit.tpl.html";
                $("#modal-viewer").modal("show");
            };

            $scope.openDeferralReason = function () {
                $scope.modal.url = "js/views/view/defer.tpl.html";
                $("#modal-viewer").modal("show");
            };

            // Loading Service Request
            loadService();
        }]);
